import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonHasPaymentItem, PersonHasPayment } from '../models';

export class PersonHasPaymentApi extends ApiModule {
  protected endpoint = '/person-has-payment';

  public async pagePersonHasPayments(params: any) {
    return this.api.post<PaginatedResponseData<PersonHasPaymentItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonHasPaymentDetails(id: number) {
    return this.api.get<PersonHasPayment>(`${this.endpoint}?id=${id}`);
  }

  public savePersonHasPayment(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonHasPayment(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
